import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  role: string;
  location: string;
  content: string;
}
export function TestimonialCard({
  name,
  age,
  role,
  location,
  content
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300" data-id="element-20">
      <div className="flex items-center gap-1 mb-4" data-id="element-21">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-22" />)}
      </div>
      <p className="text-gray-700 mb-6 italic leading-relaxed" data-id="element-23">"{content}"</p>
      <div className="flex items-center gap-3" data-id="element-24">
        <div className="w-10 h-10 rounded-full bg-blue-900 flex items-center justify-center text-white font-bold text-sm" data-id="element-25">
          {name.charAt(0)}
        </div>
        <div data-id="element-26">
          <h4 className="font-bold text-gray-900 text-sm" data-id="element-27">
            {name}, {age}
          </h4>
          <p className="text-xs text-gray-500" data-id="element-28">{role}</p>
          <p className="text-xs text-gray-400" data-id="element-29">{location}</p>
        </div>
      </div>
    </div>;
}